import { useState, useEffect } from 'react'

const DIMENSIONS_VERTICAL = ['height', 'offsetHeight', 'margin-top', 'margin-bottom']
const DIMENSIONS_HORIZONTAL = ['width', 'offsetWidth', 'margin-left', 'margin-right']

export default (ref, isVertical) => {
  const [maxChilrenQuantity, setMaxChilrenQuantity] = useState(1)
  const [computedMargin, setComputedMargin] = useState(0)

  const [var1, var2, marg1, marg2] = isVertical ? DIMENSIONS_VERTICAL : DIMENSIONS_HORIZONTAL

  useEffect(() => {
    if (!ref.current) {
      throw new Error('Ref should not be empty for use maxChildrenQuantity')
    } else {
      const computedStyles = window.getComputedStyle(ref.current.firstElementChild)
      const offset1 = parseFloat(computedStyles[marg1])
      const offset2 = parseFloat(computedStyles[marg2])
      /* 
        When screen is wide both marginTop and marginBottom are set.
        In narrow responsive mode only marginRight is set, so margins are not collapsed.
      */
      setComputedMargin((offset1 + offset2) / (offset1 && offset2 ? 2 : 1))
    }
  }, [])

  useEffect(() => {
    const O = new ResizeObserver((entries) => {
      /* 
        requestAnimationFrame is needed so it can deliver all observations within a single animation frame. 
        Otherwise it will show the following error: "ResizeObserver loop limit exceeded"
      */
      window.requestAnimationFrame(() => {
        if (!Array.isArray(entries) || !entries.length) {
          return
        }
        const firstElementChild = entries[0].target?.firstElementChild
        if (firstElementChild) {
          setMaxChilrenQuantity(Math.trunc(entries[0].contentRect[var1] / (firstElementChild[var2] + computedMargin)))
        }
      })
    })
    O.observe(ref.current)
    return () => {
      O.disconnect()
      setMaxChilrenQuantity(1)
    }
  }, [computedMargin])

  return maxChilrenQuantity
}
